import validate from "/usr/src/app/content/n3-packages-d902bac9-f43d-4dcc-ae5d-b85c6dd9b29b/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-d902bac9-f43d-4dcc-ae5d-b85c6dd9b29b/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}